import { Route } from '@angular/router';

export const SiteRoutes: Route[] = [
  {
    path: 'site',
    children: [
      // {
      //   path: 'banner',
      //   loadComponent: () => import('../pages/site/banner/banner.page'),
      // },
      {
        path: 'business-info',
        loadComponent: () =>
          import('../pages/site/business-info/business-info.page'),
      },
      {
        path: 'partner',
        loadComponent: () => import('../pages/site/partner/partner.page'),
      },
      {
        path: 'portfolio',
        loadComponent: () => import('../pages/site/portfolio/portfolio.page'),
      },
      {
        path: 'certificate',
        loadComponent: () =>
          import('../pages/site/certificate/certificate.page'),
      },
      {
        path: 'review',
        loadComponent: () => import('../pages/site/review/review.page'),
      },
      {
        path: 'blog',
        loadComponent: () => import('../pages/site/blog/blog.page'),
      },
      {
        path: 'terms',
        loadComponent: () => import('../pages/site/terms/terms.page'),
      },
      {
        path: 'popup',
        loadComponent: () => import('../pages/site/popup/popup.page'),
      },
      // {
      //   path: 'history',
      //   loadComponent: () => import('../pages/history/history.page'),
      // },
    ],
  },
];
